import { Field } from '@kanda-libs/ks-component-ts';
import { FinanceRate } from '@kanda-libs/ks-frontend-services';

import useCommissionCheckbox from './useCommissionCheckbox';

export interface CommissionCheckboxProps {
  selectedRate: FinanceRate;
}

const CommissionCheckbox: React.FunctionComponent<CommissionCheckboxProps> =
  function ({ selectedRate }) {
    const { copy } = useCommissionCheckbox(selectedRate);
    return (
      <div className="col-span-2 mt-4">
        <Field.FingerprintBooleanInput
          name="commission"
          handle="checkbox"
          fieldText={
            <p className="text-12-18">
              {copy} I have also read and agree to{' '}
              <a
                target="_black"
                rel="noreferrer"
                href="https://storage.googleapis.com/ideal-terms/checkout%20T%26C's%20Website%20%2B%20Service.pdf"
                className="text-purple-200 underline"
              >
                Ideal4Finance&apos;s Terms &amp; Conditions
              </a>
              .
            </p>
          }
        />
      </div>
    );
  };

export default CommissionCheckbox;
